import React from 'react';
import styles from "./textinput.module.scss";
import TextField from '@material-ui/core/TextField';
import {
    fade,
    ThemeProvider,
    withStyles,
    makeStyles,
    createMuiTheme,
} from '@material-ui/core/styles';
import FormHelperText from '@material-ui/core/FormHelperText';
import moment from "moment";
const useStyles = makeStyles((theme) => ({
    root: {
        '& .MuiTextField-root': {
            margin: theme.spacing(1),
            width: '50ch',
        },
    },
}));
const date_now = new Date();
const CssTextField = withStyles({
    root: {
        '& label': {
            color: '#DADADA',
        },
        '& label.Mui-focused': {
            color: '#FBB0B5',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#EFEFEF',
        },
        '& .MuiInput-underline:before': {
            borderBottomColor: '#EFEFEF',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'red',
            },
            '&:hover fieldset': {
                borderColor: '#EFEFEF',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#EFEFEF',
            },
        },
    },
})(TextField);
function TextInput(props) {
    const classes = useStyles();
    return (
        <div className={styles.text_input}>
            <CssTextField
                InputProps={{
                    readOnly: props.readOnly,
                }}
                inputProps={{ min: "1900-11-30", max: moment(date_now).format('yyyy-MM-D') }}
                onKeyDown={(e) => props.onKeyDown(e)}
                className={classes.margin}
                onChange={(e) => {
                    let value = e.target.value;
                    props.onChange(value);
                }}
                label={props.label}
                type={props.type}
                value={props.value}
                InputLabelProps={{
                    shrink: props.type === "date" ? true : undefined
                }}
            />
        </div>
    );
}
export default TextInput;